import { Pipe, PipeTransform } from '@angular/core';

type AnyObj = Record<string, any>;

@Pipe({
  name: 'trierPar',
})
export class TrierParPipe implements PipeTransform {
  transform<T extends AnyObj>(values: T[] | undefined | null, key: string | null, ...otherKeys: string[]): T[] {
    if (!values) return [];

    if (!key) return values;

    const sortKeys: string[] = [key, ...otherKeys];

    const copy = [...values];

    const getValue = (obj: T, key: string): any => key.split('.').reduce((current, key) => current?.[key], obj);

    copy.sort((a, b) => {
      for (const k of sortKeys) {
        const aVal = getValue(a, k);
        const bVal = getValue(b, k);

        if (aVal == null && bVal == null) continue;
        if (aVal == null) return 1;
        if (bVal == null) return -1;

        let cmp = 0;

        if (typeof aVal === 'string' && typeof bVal === 'string') {
          cmp = aVal.localeCompare(bVal);
        } else if (aVal < bVal) {
          cmp = -1;
        } else if (aVal > bVal) {
          cmp = 1;
        }

        if (cmp !== 0) {
          return cmp; // asc
        }
      }
      return 0;
    });

    return copy;
  }
}
